import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faPlusCircle, faTimes } from '@fortawesome/pro-light-svg-icons'

import { Box, Button } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'
import { confirmAction } from '@functions/entity'

import type { Dispatch, SetStateAction } from 'react'

import type { AdCopyModel } from '@models/types'

import type { UseAdCopyPayload } from '@hooks/useAdCopy'

interface AdCopyActionsProps {
  adCopy: AdCopyModel,
  callbacks: {
    assignAdCopiesToCampaign: UseAdCopyPayload['callbacks']['assignAdCopiesToCampaign'],
    createOrUpdateAdCopy: UseAdCopyPayload['callbacks']['createOrUpdateAdCopy'],
    setState: Dispatch<SetStateAction<{ commentMode: boolean }>>,
  },
  campaignId?: number,
}

const AdCopyActions = (props: AdCopyActionsProps) => {
  const { adCopy, callbacks, campaignId } = props
  const {
    assignAdCopiesToCampaign,
    createOrUpdateAdCopy,
    setState,
  } = callbacks

  const { copied_to_campaign, review_status } = adCopy

  const confirmActionPayload = {
    callbacks: {
      actionFn: assignAdCopiesToCampaign,
      afterAction: () => {
        createOrUpdateAdCopy({ ...adCopy, review_status: 'approved' })
        setState({ commentMode: false })
      },
    },
    options: {
      entityParams: {
        ad_copy_ids: [adCopy.id],
        campaign_id: campaignId,
      },
      confirmButtonColor: '#43ac6a',
      icon: 'success',
    },
    strings: {
      actionString: 'add to',
      confirmString: 'Are you sure? This will overwrite any existing ad copy and cannot be undone.',
      entityName: 'campaign',
      toastText: 'Ad Copy Added to Campaign',
    },
  }

  const approveAdCopyPayload = {
    callbacks: {
      action: createOrUpdateAdCopy,
      afterAction: () => setState({ commentMode: false }),
    },
    entityParams: {
      ...adCopy,
      review_status: 'approved',
    },
    toastText: 'Ad Copy Approved',
  }

  const rejectAdCopyPayload = {
    callbacks: {
      action: createOrUpdateAdCopy,
      afterAction: () => setState({ commentMode: true }),
    },
    entityParams: {
      ...adCopy,
      review_status: 'rejected',
    },
    toastText: 'Ad Copy Rejected',
  }

  return (
    <Box>
      <Box justifyContent="flex-end">
        <Button
          buttonStyle="primaryEdit"
          icon={<FontAwesomeIcon icon={faPlusCircle} />}
          disabled={copied_to_campaign}
          // @ts-expect-error TS2345
          onClick={() => confirmAction(confirmActionPayload)}
          size="medium"
          //@ts-expect-error
          width="fit-content"
        >
          Add to Campaign
        </Button>

        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faCheck} />}
          disabled={review_status === 'approved'}
          onClick={() => handleCallbackAction(approveAdCopyPayload)}
          //@ts-expect-error
          marginLeft="medium"
          size="medium"
          width="fit-content"
        >
          Approve
        </Button>

        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faTimes} />}
          disabled={review_status === 'rejected' || copied_to_campaign}
          onClick={() => handleCallbackAction(rejectAdCopyPayload)}
          //@ts-expect-error
          marginLeft="medium"
          size="medium"
          width="fit-content"
        >
          Reject
        </Button>
      </Box>
    </Box>
  )
}

export default AdCopyActions
